import { useGLTF } from '@react-three/drei'
import { useMemo } from 'react'
import { useTrackController } from '../track/useTrackController'
import { gltfAsset } from '../../assetStore'
import { applyMaterial, useAtlasMaterial } from '../../materials/atlasMaterial'

const endAreaFLoorPath = gltfAsset.EndArea
const endAreaFinishLine = gltfAsset.Finishline

export function EndArea() {
    // Load assets
    const floor = useGLTF(endAreaFLoorPath)
    const finish = useGLTF(endAreaFinishLine)
    const atlasMaterial = useAtlasMaterial()

    const finishLineScene = useMemo(
        () => applyMaterial(finish.scene, atlasMaterial),
        [finish.scene, atlasMaterial],
    )

    // Position group and last path point
    const trackController = useTrackController()
    const transform = useMemo(() => {
        const frame = trackController.frameAtPosition(
            trackController.getTrackLength()
        )

        return {
            position: frame.position.toArray() as [number, number, number],
            quaternion: frame.cameraQuaternion.toArray() as [number, number, number, number],
        }
    }, [trackController])

    return (
        <group
            position={transform.position}
            quaternion={transform.quaternion}>
            <primitive
                name={'end platform'}
                object={floor.scene}
            />
            <primitive
                name={'finish line'}
                object={finishLineScene}
            />  
        </group>
        
    )
}
